import { render, staticRenderFns } from "./aRefundRecord.vue?vue&type=template&id=6c36b584&"
import script from "./aRefundRecord.vue?vue&type=script&lang=ts&"
export * from "./aRefundRecord.vue?vue&type=script&lang=ts&"
import style0 from "./aRefundRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports